import React, { useEffect, useState } from 'react';
import Container from '../Container/Container';
import { Wrapper, TableWrapp, TableStyled, ButtonBox, Span } from './TablePrice.styled';
import { GiSandsOfTime } from "react-icons/gi";
import { GiMoneyStack } from "react-icons/gi";
import { PiSealPercentThin } from "react-icons/pi";
import { VscDebugBreakpointData } from "react-icons/vsc";
import dataServices from '../../resources/dataServices.json'
import ModalWindow from '../ModalWindow/ModalWindow';
import Button from '../Button/Button';

const TablePrice = () => {

    const [isShowModal, setIsShowModal] = useState(false);

    const handleButton = () => setIsShowModal(!isShowModal);

    const handleKeyDown = (event) => {
        if (event.key === 'Escape') {
            setIsShowModal(false);
        }
    };
    useEffect(() => {
        if (isShowModal) {
            window.addEventListener('keydown', handleKeyDown);
        } else {
            window.removeEventListener('keydown', handleKeyDown);
        }
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [isShowModal]);


    return (
        <>
            <div id="back-to-top-anchor"></div>
            <Container>
                <Wrapper>
                    {dataServices.map((category, categoryIndex) => (
                        <TableWrapp key={`category-${categoryIndex}`}>
                            <h2>{category.name}</h2>
                            {category.categories.map((item, itemIndex) => (
                                <React.Fragment key={`item-${itemIndex}`}>
                                    <h3 key={itemIndex}><VscDebugBreakpointData /> {item.description}</h3>
                                    <TableStyled>
                                        <thead>
                                            <tr key={categoryIndex}>
                                                <th>Zabieg</th>
                                                <th><Span><GiSandsOfTime /> Czas trwania</Span></th>
                                                <th><Span><GiMoneyStack /> Cena</Span></th>
                                                {item.services.some(service => service.discount) && (
                                                    <th key="promocja"><Span><PiSealPercentThin /> Promocja</Span></th>
                                                )}
                                                <th style={{ width: '0.01px' }}></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {item.services.map((service, serviceIndex) => (
                                                <tr key={`service-${serviceIndex}`}>
                                                    <td>{service.name}</td>
                                                    <td>{service.duration}</td>
                                                    <td>{service.price}</td>
                                                    {service.discount && (
                                                        <td key={`discount-${serviceIndex}`} className='discount'>{service.discount}</td>)}
                                                    <td style={{ width: '1px' }}>
                                                        <ButtonBox>
                                                            <Button small={true} onClick={handleButton}>UMÓW SIĘ</Button>
                                                        </ButtonBox>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </TableStyled>
                                </React.Fragment>))}
                        </TableWrapp>
                    ))}
                    {isShowModal && <ModalWindow toggleShowMenu={handleButton} />}
                </Wrapper>
            </Container>
        </>
    )
};

export default TablePrice;